<ion-app>
  @if (vm.company.selection(); as company) {
    <div class="support-banner" role="status">
      <span>{{ company.companyName }}（{{ company.companyId }}）に変身中・閲覧のみ</span>
      <ion-button
        type="button"
        size="small"
        color="dark"
        fill="outline"
        (click)="vm.disableHandler($event, vm.company.exit())"
        >変身を解除</ion-button
      >
    </div>
  }
  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content" type="overlay" [disabled]="!(authState$ | async)?.emailVerified">
      <ion-content>
        <ion-list id="inbox-list">
          <ion-list-header class="ion-margin-bottom">おーだーシステム</ion-list-header>
        </ion-list>
        <ion-menu-toggle auto-hide="false">
          <ion-list>
            <ion-item-group>
              <ion-item
                routerDirection="root"
                routerLink="/main/search/transaction"
                lines="none"
                [detail]="false"
                routerLinkActive="selected"
              >
                <ion-icon slot="start" name="mail-outline"></ion-icon>
                <ion-label>取引検索</ion-label>
              </ion-item>
              <ion-item
                routerDirection="root"
                routerLink="/main/invoice"
                lines="none"
                [detail]="false"
                routerLinkActive="selected"
              >
                <ion-icon slot="start" name="document-outline"></ion-icon>
                <ion-label>請求書</ion-label>
              </ion-item>
              <ion-item
                routerDirection="root"
                routerLink="main/estimate"
                lines="none"
                [detail]="false"
                routerLinkActive="selected"
              >
                <ion-icon slot="start" name="document-outline"></ion-icon>
                <ion-label>見積書</ion-label>
              </ion-item>
              @if (canManageUsers()) {
                <ion-item
                  routerDirection="root"
                  routerLink="/main/access"
                  lines="none"
                  [detail]="false"
                  routerLinkActive="selected"
                >
                  <ion-icon slot="start" name="people-outline"></ion-icon>
                  <ion-label>ユーザマネージャー</ion-label>
                </ion-item>
              }
              <ion-item
                routerDirection="root"
                routerLink="/main/settings"
                lines="none"
                [detail]="false"
                routerLinkActive="selected"
              >
                <ion-icon slot="start" name="settings-outline"></ion-icon>
                <ion-label>設定</ion-label>
              </ion-item>
            </ion-item-group>
          </ion-list>
        </ion-menu-toggle>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
